export async function initSocialCharts({ d3, Plot }) {
  const socialCsvUrl = 'https://s3.us-west-1.amazonaws.com/vegasmattstats.info/social.csv'

  const colorPalette = {
    VM: '#96e6ab',
    EJ: '#76ace0',
    WBG: '#df87a8',
    W2J: '#f4d353',
  };
  const fallbackColors = [
    '#b3e2cd',
    '#fdcdac',
    '#cbd5e8',
    '#f4cae4',
    '#e6f5c9',
    '#fff2ae',
    '#f1e2cc',
    '#cccccc',
    '#8dd3c7',
    '#ffffb3',
  ];

  const getColor = (index) => {
    const colors = Object.values(colorPalette).concat(fallbackColors);
    return colors[index % colors.length];
  };

  const populateFourBoxes = (row) => {
    const bigCheckAmountEl = document.getElementById('bigCheckAmount');
    if (bigCheckAmountEl) {
      bigCheckAmountEl.setAttribute('class', 'highlight-green');
      bigCheckAmountEl.textContent = row['big_check_amount'] || '0';
    }

    const bigChecksEl = document.getElementById('bigChecks');
    if (bigChecksEl) {
      bigChecksEl.textContent = row['big_checks'] || '0';
    }

    const triplePopsEl = document.getElementById('triplePopsValue');
    if (triplePopsEl) {
      triplePopsEl.textContent = row['triple_pops'] || '0';
    }

    const oneTicketersEl = document.getElementById('oneTicketersSlot');
    if (oneTicketersEl) {
      oneTicketersEl.textContent = row['one_ticketers_slot'] || '0';
    }
  };

  const createSocialTrendsChart = (row) => {
    const trendsMap = {
      big_checks: 'Big Checks',
      spirit_fingers: 'Spirit Fingers',
      victory_laps: 'Victory Laps',
      triple_pops: 'Triple Pops',
      wbg_belly_laughs: 'WBG Belly Laughs',
      crickets: 'Crickets',
      bonu_in_a_bonu: 'Bonu in a Bonu',
      first_spin_johnson: 'First Spin Johnson',
      next_spin_johnson: 'Next Spin Johnson',
      accidental_fast_spins: 'Accidental Fast Spins',
      vm_wears_chain: 'VM Wears Chain',
      ej_remembers_to_add_content: 'EJ Remembers to Add Content',
      blazed_it_and_420: 'Blazed it / 420',
      vm_story_triggers_a_bonus: 'VM Story Triggers a Bonus',
      wbg_pun_counter: 'WBG Puns',
      double_pops: 'Double Pops',
      bbbs: 'Big Beautiful Buffalo Spins',
    };

    let trendsData = Object.keys(trendsMap)
      .map((key) => ({ label: trendsMap[key], count: +row[key] || 0 }))
      .filter((entry) => entry.count > 0)
      .sort((a, b) => b.count - a.count);

    const margin = { top: 20, right: 20, bottom: 50, left: 50 };
    const width = 800 - margin.left - margin.right;
    const height = 600 - margin.top - margin.bottom;

    const container = document.getElementById('socialTrendsChart');
    if (!container) return;

    container.innerHTML = '';

    const svg = d3
      .select(container)
      .append('svg')
      .attr('viewBox', `0 0 ${width + margin.left + margin.right} ${height + margin.top + margin.bottom}`)
      .attr('preserveAspectRatio', 'xMidYMid meet')
      .style('width', '100%')
      .style('height', 'auto')
      .append('g')
      .attr('transform', `translate(${margin.left}, ${margin.top})`);

    const x = d3.scaleLinear().domain([0, d3.max(trendsData, (d) => d.count)]).range([0, width]);
    const y = d3.scaleBand().domain(trendsData.map((d) => d.label)).range([0, height]).padding(0.1);

    svg
      .append('g')
      .attr('transform', `translate(0, ${height})`)
      .call(d3.axisBottom(x).ticks(5))
      .selectAll('text')
      .style('font-size', '16px')
      .style('fill', '#444');

    svg
      .append('line')
      .attr('x1', 0)
      .attr('x2', 0)
      .attr('y1', 0)
      .attr('y2', height)
      .attr('stroke', '#444')
      .attr('stroke-width', 2);

    svg
      .selectAll('rect')
      .data(trendsData)
      .enter()
      .append('rect')
      .attr('x', 0)
      .attr('y', (d) => y(d.label))
      .attr('width', (d) => x(d.count))
      .attr('height', y.bandwidth())
      .attr('fill', (_, i) => getColor(i))
      .append('title')
      .text((d) => `${d.label}: ${d.count}`);

    svg
      .selectAll('text.bar-label')
      .data(trendsData)
      .enter()
      .append('text')
      .attr('class', 'bar-label')
      .attr('x', (d) => (x(d.count) > 100 ? x(d.count) - 10 : x(d.count) + 10))
      .attr('y', (d) => y(d.label) + y.bandwidth() / 2 + 5)
      .attr('text-anchor', (d) => (x(d.count) > 150 ? 'end' : 'start'))
      .style('font-size', '20px')
      .style('fill', '#444')
      .text((d) => `${d.label} (${d.count})`);
  };

  const createSocialSayingsChart = (row) => {
    const sayingsMap = {
      sando: 'Sando!',
      idiot_counter: 'Idiot',
      lets_enjoy_this: "Let's Enjoy This!",
      fire_it_in: 'Fire it in there!',
      thats_what_she_said: "That's what she said!",
      innage: 'Innage',
      was_it_over_when_the_germans: 'Was it over when the Germans?',
      now_were_loggin: "Now we're loggin'!",
      how_much_was_that: 'How much was that?',
      poke_in_the_eye: 'Better than a poke in the eye!',
      sure_get_5_a_lot: 'You sure get 5 a lot!',
      those_should_be_wild: 'Those should be wild!',
      jingles: 'Jingles',
      coins: 'Coins',
      thats_a_massive_guys: "That's a massive guys",
      baby_doll: 'Baby Doll (W2J)',
      a_lot_of_people_are_saying_it: 'A lot of people are saying it!',
      flags: 'Flags!',
      balls: 'Balls!',
      hats: 'Hats!',
    };

    let socialData = Object.keys(sayingsMap)
      .map((key) => ({ saying: sayingsMap[key], count: +row[key] || 0 }))
      .filter((entry) => entry.count > 0)
      .sort((a, b) => b.count - a.count)
      .slice(0, 15);

    const margin = { top: 20, right: 20, bottom: 50, left: 180 };
    const width = 800 - margin.left - margin.right;
    const height = 600 - margin.top - margin.bottom;

    const container = document.getElementById('socialSayingsChart');
    if (!container) return;

    container.innerHTML = '';

    const svg = d3
      .select(container)
      .append('svg')
      .attr('viewBox', `0 0 ${width + margin.left + margin.right} ${height + margin.top + margin.bottom}`)
      .attr('preserveAspectRatio', 'xMidYMid meet')
      .style('width', '100%')
      .style('height', 'auto')
      .append('g')
      .attr('transform', `translate(${margin.left}, ${margin.top})`);

    const x = d3.scaleLinear().domain([0, d3.max(socialData, (d) => d.count)]).range([0, width]);
    const y = d3.scaleBand().domain(socialData.map((d) => d.saying)).range([0, height]).padding(0.1);

    svg
      .append('g')
      .attr('transform', `translate(0, ${height})`)
      .call(d3.axisBottom(x).ticks(5))
      .selectAll('text')
      .style('font-size', '16px')
      .style('fill', '#444');

    svg
      .append('g')
      .call(d3.axisLeft(y))
      .selectAll('text')
      .style('font-size', '16px')
      .style('fill', '#444');

    svg
      .selectAll('rect')
      .data(socialData)
      .enter()
      .append('rect')
      .attr('x', 0)
      .attr('y', (d) => y(d.saying))
      .attr('width', (d) => x(d.count))
      .attr('height', y.bandwidth())
      .attr('fill', (_, i) => getColor(i))
      .append('title')
      .text((d) => `${d.saying}: ${d.count}`);
  };

  const populateBlackjackStats = (row) => {
    const totalHands = +(row.black_jack_hands_played_total || row.bj_total_hands) || 0;
    const dealerHas10Count = +(row.black_jack_dealer_has_10_count || row.bj_dealer_has_10) || 0;
    const dealerHas10Pct = totalHands ? (dealerHas10Count / totalHands) * 100 : 0;
    const dealerNo10Pct = 100 - dealerHas10Pct;

    const handsEl = document.getElementById('bjHands');
    if (handsEl) handsEl.textContent = totalHands.toString();

    const has10El = document.getElementById('bjDealerHas10');
    if (has10El) has10El.textContent = dealerHas10Count.toString();

    const has10PctEl = document.getElementById('bjDealerHas10Pct');
    if (has10PctEl) has10PctEl.textContent = `${dealerHas10Pct.toFixed(2)}%`;

    const no10PctEl = document.getElementById('bjDealerNo10Pct');
    if (no10PctEl) no10PctEl.textContent = `${dealerNo10Pct.toFixed(2)}%`;
  };

  const createGruntDonut = (row) => {
    const totalGrunts = +row.ej_grunts_total || 0;
    const successfulGrunts = +row.ej_grunt_bonus || 0;
    const unsuccessfulGrunts = totalGrunts - successfulGrunts;
    const successPercent = totalGrunts ? ((successfulGrunts / totalGrunts) * 100).toFixed(2) : '0.00';

    const totalEl = document.getElementById('totalGrunts');
    if (totalEl) totalEl.textContent = totalGrunts.toString();

    const successEl = document.getElementById('sucGrunt');
    if (successEl) successEl.textContent = successfulGrunts.toString();

    const failEl = document.getElementById('unGrunt');
    if (failEl) failEl.textContent = unsuccessfulGrunts.toString();

    const percentEl = document.getElementById('gruntPercent');
    if (percentEl) percentEl.textContent = `${successPercent}%`;

    const gruntData = [
      { resultType: 'Successful', count: successfulGrunts },
      { resultType: 'Unsuccessful', count: unsuccessfulGrunts },
    ];

    const width = 400;
    const height = 400;
    const margin = 10;
    const radius = Math.min(width, height) / 2 - margin;

    const container = document.getElementById('gruntPie');
    if (!container) return;

    d3.select(container).selectAll('*').remove();

    const svg = d3
      .select(container)
      .append('svg')
      .attr('viewBox', `0 0 ${width} ${height}`)
      .style('width', '100%')
      .style('height', 'auto')
      .append('g')
      .attr('transform', `translate(${width / 2}, ${height / 2})`);

    const color = d3.scaleOrdinal().domain(gruntData.map((d) => d.resultType)).range(['#96e6ab', '#df87a8']);

    const pie = d3.pie().value((d) => d.count);
    const dataReady = pie(gruntData);
    const arc = d3.arc().innerRadius(70).outerRadius(radius);

    svg
      .selectAll('path')
      .data(dataReady)
      .join('path')
      .attr('d', arc)
      .attr('fill', (d) => color(d.data.resultType))
      .attr('stroke', 'white')
      .style('stroke-width', '2px');

    const labelArc = d3.arc().innerRadius(radius * 0.5).outerRadius(radius * 0.8);
    svg
      .selectAll('text')
      .data(dataReady)
      .join('text')
      .text((d) => `${d.data.resultType} (${d.data.count})`)
      .attr('transform', (d) => `translate(${labelArc.centroid(d)})`)
      .style('text-anchor', 'middle')
      .style('font-size', '16px')
      .style('fill', '#444');
  };

  try {
    const socialData = await d3.csv(socialCsvUrl);
    if (!socialData.length) return;

    const row = socialData[0];

    populateFourBoxes(row);
    createSocialTrendsChart(row);
    createSocialSayingsChart(row);
    populateBlackjackStats(row);
    createGruntDonut(row);
  } catch (error) {
    console.error('[SocialCharts] Failed to initialise social charts', error);
  }
}
